import { Sheet, SheetContent, SheetTrigger } from '@e2n/ui';
import { Navigation } from '@/domain/mitarbeiter/features/anlageassistent/components/Navigation';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Header() {
  const { ctx } = useAnlageassistentContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];

  return (
    <div className="flex gap-1">
      <h2 className="text-neutrals-900 text-sm font-semibold leading-5">
        {currentStep.title}
      </h2>
      {currentStep.type === 'step' && (
        <span className="text-neutrals-700 text-sm font-normal">
          {`${ctx.state.currentSubStepIndex + 1} von ${currentStep.subSteps.length > 0 ? currentStep.subSteps.length : 1}`}
        </span>
      )}
      <FontAwesomeIcon
        icon={faChevronDown}
        className="size-4 text-neutrals-700 md:hidden"
      />
    </div>
  );
}

function MobileHeaderWrapper() {
  return (
    <Sheet>
      <SheetTrigger className="md:hidden">
        <Header />
      </SheetTrigger>
      <SheetContent side="left" className="w-screen pt-16">
        <Navigation />
      </SheetContent>
    </Sheet>
  );
}

export { Header, MobileHeaderWrapper };
